export const findFirstOrderMonth = (orderItems) => {
  return orderItems.reduce((firstMonth, item) => {
    return item.month < firstMonth ? item.month : firstMonth
  }, 11) + 1
}
